/** The audit log page's vocabulary and URL state, shared with the router's `validateSearch`. */

export const ACTOR_TYPES = ["admin", "api_key", "end_user", "system", "anonymous"] as const;
export type ActorType = (typeof ACTOR_TYPES)[number];

export const ACTOR_LABELS: Record<ActorType, string> = {
  admin: "Dashboard user",
  api_key: "API key",
  end_user: "Shopper",
  system: "Platform",
  anonymous: "Anonymous",
};

export function isActorType(value: unknown): value is ActorType {
  return typeof value === "string" && (ACTOR_TYPES as readonly string[]).includes(value);
}

/** What the page reads from the URL; every filter is optional and absent means "any". */
export interface AuditLogSearch {
  tenant?: string;
  actorType?: ActorType;
  result?: "ok" | "failed";
  action?: string;
  resource?: string;
  actor?: string;
  /** `YYYY-MM-DD`, as a date input writes it. */
  from?: string;
  to?: string;
}

const DAY = /^\d{4}-\d{2}-\d{2}$/;

function text(value: unknown): string | undefined {
  return typeof value === "string" && value ? value : undefined;
}

/** The route's `validateSearch`: anything malformed is dropped rather than refused. */
export function parseAuditLogSearch(search: Record<string, unknown>): AuditLogSearch {
  return {
    tenant: text(search.tenant),
    actorType: isActorType(search.actorType) ? search.actorType : undefined,
    result: search.result === "ok" || search.result === "failed" ? search.result : undefined,
    action: text(search.action),
    resource: text(search.resource),
    actor: text(search.actor),
    from: typeof search.from === "string" && DAY.test(search.from) ? search.from : undefined,
    to: typeof search.to === "string" && DAY.test(search.to) ? search.to : undefined,
  };
}
